
import React from "react";
import Page from "./Page";
import Footer from "./Footer";
import Link from 'react-router-dom/Link';
import illuDesign from './assets/img/illuDesign.svg';
import illuKonzeption from './assets/img/illuKonzeption.svg';
import phil from "./assets/img/banana2.jpg";
import jenny from "./assets/img/jenny.png";

import ohstopit from "./assets/img/ohstopit.jpg";
import philVideo from "./assets/img/about3.webm";
import philVideoMp4 from "./assets/img/about3.mp4";
import illuEntwicklung from './assets/img/illuEntwicklung.svg';
import marlon from './assets/img/marlon.png';
import pickshareMenu from './assets/img/pickshareMenu-small.mp4';
import anymotionTeaser from "./assets/img/any.mp4";
import ReactPlayer from 'react-player';
import Slider from "react-slick";
import { Controller, Scene } from "react-scrollmagic";
import Draggable from 'react-draggable'; // The default
import Hyphenated from 'react-hyphen';
import {motion} from 'framer-motion';
const transition = {duration:.3, ease: [0.6, 0.01, .4, 0.9]};
import { MyContext } from './Context';



import de from 'hyphenated-de';

class SimpleSlider extends React.Component {
  render() {
    var settings = {
      infinite: false,
      autoplaySpeed: 5000,
      slidesToShow: 1.25,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.25,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1.9,
            slidesToScroll: 1,
          }
        },

      ]
    };
    return (
      <MyContext.Consumer>
        {(context) => (
      <Slider className="testemonials-section testemonial-slides -displayMobile  -displayTablet " {...settings}>

      <div className="testemonial ">
        <div className=" testemonial-slide">
          <p className="p-mini testemonial-text">
            <em>„</em>{  context.state.translation.default.testemonials.kevin}
            <em>“</em>{" "}
          </p>
          <div className="">
            <div  className="col img-wrap">
              <img alt="" src="https://app-pilots.de/img/kevin.png" />
            </div>
            <div className="col">
              <p className="f-blue p-tiny uppercase">Kevin Beyer</p>
              <p className="p-tiny">CEO App-pilots</p>
            </div>
          </div>
        </div>
      </div>

          <div className="testemonial ">
            <div className=" testemonial-slide">
              <p className="p-mini testemonial-text">
                <em>„</em>{  context.state.translation.default.testemonials.marlon}
                <em>“</em>
              </p>
              <div className="">
                <div  className="col img-wrap">
                  <img alt="" src={marlon} />
                </div>
                <div className="col">
                  <p className="f-blue p-tiny uppercase">Marlon Besuch</p>
                  <p className="p-tiny">CEO Microsynetics</p>
                </div>
              </div>
            </div>
          </div>
          <div className="testemonial ">
            <div className=" testemonial-slide">
              <p className="p-mini testemonial-text">
                <em>„</em>{  context.state.translation.default.testemonials.jenny}
                <em>“</em>{" "}
              </p>
              <div >
            <div  className="col img-wrap">
                  <img alt="" src={jenny} />
                </div>
                <div className="col">
                  <p className="f-blue p-tiny uppercase">Jennifer Omumi</p>
                  <p className="p-tiny">Kunstwerkstatt Omumi</p>
                </div>
              </div>
            </div>
          </div>
                    <div className="testemonial-rhenus testemonial col-50_sm-100 ">
                      <div className=" testemonial-slide">
                        <img src={ohstopit}/>
                      </div>
                    </div>


      </Slider>
    )}
  </MyContext.Consumer>
    );
  }
}

class About extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

    componentDidMount() {
      window.scrollTo(0, 0);
    }


  render() {

    return (
      <MyContext.Consumer>
        {(context) => (
      <Page
        pageName="About"
                loaderText="Das bin ich"
        pageType="About"
        pageHero="Digitale Produkte, die Spaß machen."
        pageStyle="bright"
      >




        <React.Fragment>
            <Controller>
              <Scene
                duration={200}
                triggerElement={".bigImage-portrait"}
                triggerHook={0.2}
                addIndicators={true}
                classToggle="-active"
              >
                              {(progress, event) => {


                                                            if(progress > 0){
                                                                  var isPlaying = true;

                                                            }
                                                            else{
                                                                var isPlaying = false;
                                                            }

                                return(       <motion.div initial={{y:'10%'}} animate={{ y:'0', transition:{ delay: 0, ...transition}}}  className="video-wrap bigImage-portrait" >

                                                      <ReactPlayer className={ status ? "-active" : ""} playing={isPlaying}  muted={true} loop  height='100%' width="100%" url={[philVideo, philVideoMp4]}  />
                                          </motion.div>
                              )
                                 }}


                </Scene>
              </Controller>
        </React.Fragment>


    <div className="wrap about-textBlock">


        <div className="grid -center" >

        <div className="col_xs-100 col-65 ">
          <p className="p-big">
        {  context.state.translation.default.about.introP}
          </p>
  </div>
        </div>


</div>
<section className="testemonials-section testemonial-slides  -displayDesktop -hideTablet">
<div className="meinungen">

<div class="meinungen-wrap">
<Draggable>
<div className="testemonial-rhenus testemonial col-50_sm-100 ">
<div className=" testemonial-slide">
<p className="p-mini testemonial-text"><Hyphenated language={de}>
  <em>„</em>{  context.state.translation.default.testemonials.jenny}</Hyphenated>
  <em>“</em>{" "}
</p>
<div >
<div  className="col img-wrap">
    <img alt="" src={jenny} />
  </div>
  <div className="col">
    <p className="f-blue p-tiny uppercase">Jennifer Omumi</p>
    <p className="p-tiny">Kunstwerkstatt Omumi</p>
  </div>
</div>
</div>
</div>
</Draggable>
<Draggable>
<div className="testemonial-rhenus testemonial col-50_sm-100 ">
<div className=" testemonial-slide">
<img src={ohstopit}/>
</div>
</div>

</Draggable>
<Draggable>
<div className="testemonial-rhenus testemonial col-50_sm-100 ">
<div className=" testemonial-slide">
<p className="p-mini testemonial-text"><Hyphenated language={de}>
  <em>„</em>{  context.state.translation.default.testemonials.marlon}</Hyphenated>
  <em>“</em>{" "}
</p>
<div className="">
  <div  className="col img-wrap">
    <img alt="" src={marlon} />
  </div>
  <div className="col">
    <p className="f-blue p-tiny uppercase">Marlon Besuch</p>
    <p className="p-tiny">CEO Microsynetics</p>
  </div>
</div>
</div>
</div>
</Draggable>
<Draggable>
<div className="testemonial-rhenus testemonial col-50_sm-100">
<div className=" testemonial-slide">
<p className="p-mini testemonial-text">
  <em>„</em><Hyphenated language={de}>        {  context.state.translation.default.testemonials.kevin}</Hyphenated>
  <em>“</em>{" "}
</p>
<div className="">
  <div  className="col img-wrap">
    <img alt="" src="https://app-pilots.de/img/kevin.png" />
  </div>
  <div className="col">
    <p className="f-blue p-tiny uppercase">Kevin Beyer</p>
    <p className="p-tiny">CEO App-pilots</p>
  </div>
</div>
</div>
</div>
</Draggable>

<div className="drag-indicator">
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100"
  height="100"
  x="0"
  y="0"
  viewBox="0 0 100 100"
>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M29.577 36.118a1.953 1.953 0 00-2.752.287l-1.835 2.264v-13.63h13.603l-2.26 1.838a1.963 1.963 0 001.235 3.483c.433 0 .87-.143 1.232-.438l6.543-5.321.004-.005c.053-.043.104-.09.152-.138l.038-.042c.034-.036.067-.073.098-.111l.043-.059a1.975 1.975 0 00.21-.354 2.03 2.03 0 00.054-.133l.022-.059c.016-.047.03-.096.041-.145l.015-.056c.011-.052.02-.105.027-.158l.007-.05a1.996 1.996 0 000-.425l-.007-.05a1.887 1.887 0 00-.027-.158c-.004-.02-.01-.038-.015-.057a1.905 1.905 0 00-.041-.145l-.021-.059a2.045 2.045 0 00-.055-.133l-.03-.06a1.955 1.955 0 00-.18-.295l-.042-.056a2.14 2.14 0 00-.103-.117L45.5 21.7c-.049-.05-.1-.096-.154-.14l-.003-.003-6.543-5.321a1.954 1.954 0 00-2.753.287 1.963 1.963 0 00.286 2.757l2.26 1.838H24.99V7.487l1.834 2.265a1.95 1.95 0 002.753.287c.84-.683.967-1.917.286-2.758L24.553.725 24.548.72a1.947 1.947 0 00-.138-.152l-.04-.037a1.923 1.923 0 00-.113-.099L24.199.39a2.057 2.057 0 00-.11-.077c-.02-.014-.041-.026-.062-.038a2.098 2.098 0 00-.314-.15l-.059-.022a1.957 1.957 0 00-.145-.041l-.056-.015a2.057 2.057 0 00-.158-.026l-.05-.008a1.987 1.987 0 00-.424 0l-.05.008a2.057 2.057 0 00-.158.026l-.056.015c-.049.012-.097.025-.145.041l-.058.022a1.974 1.974 0 00-.487.265 1.923 1.923 0 00-.17.142l-.041.037a1.947 1.947 0 00-.138.152l-.004.005-5.311 6.556a1.963 1.963 0 00.286 2.758 1.954 1.954 0 002.753-.287l1.834-2.264v13.63H7.473l2.26-1.839c.839-.682.967-1.917.286-2.757a1.954 1.954 0 00-2.753-.287l-6.542 5.32-.004.004c-.054.044-.105.09-.153.14l-.034.037c-.035.038-.07.076-.102.117-.015.018-.028.037-.042.056a1.887 1.887 0 00-.181.294l-.03.061c-.02.044-.038.088-.054.133l-.022.059a2.01 2.01 0 00-.041.146l-.015.056c-.011.051-.02.104-.026.158l-.008.05a1.999 1.999 0 000 .424l.008.051c.007.053.015.106.026.158.004.019.01.037.015.056.012.05.025.098.041.145l.022.06a2.03 2.03 0 00.187.376c.024.038.05.074.077.11l.043.059c.031.038.064.075.098.111l.038.042c.048.049.099.095.152.138l.005.005 6.542 5.32a1.951 1.951 0 002.753-.286 1.963 1.963 0 00-.286-2.758l-2.26-1.838h13.603v13.63l-1.834-2.264a1.954 1.954 0 00-2.753-.287 1.963 1.963 0 00-.286 2.758l5.31 6.555.004.004c.044.054.09.105.14.154l.037.034c.037.035.076.07.116.102l.056.042c.036.027.073.054.112.078l.06.037a2.128 2.128 0 00.374.172c.048.016.096.03.146.042l.055.014c.052.012.105.02.158.027l.05.008a1.982 1.982 0 00.424 0l.05-.008c.053-.007.106-.015.158-.027l.056-.014a2.104 2.104 0 00.203-.063 1.844 1.844 0 00.316-.15l.06-.038c.039-.024.076-.05.112-.078l.056-.042c.04-.033.079-.067.117-.102l.037-.034c.049-.049.095-.1.14-.154l.002-.004 5.311-6.555a1.963 1.963 0 00-.286-2.758m64.676 40.643c-.456 4.695-2.306 9.112-5.212 12.44-3.985 4.563-9.489 6.878-16.357 6.878-12.56 0-20.028-10.84-20.1-10.946a2.005 2.005 0 00-.076-.106c-5.273-6.839-14.5-23.877-17.202-28.936-.055-.103-.002-.222.02-.234a6.145 6.145 0 013.062-.823c1.948 0 3.861.936 5.146 2.672l9.342 12.624c.503.68 1.384.96 2.186.694a1.96 1.96 0 001.343-1.861V16.869c0-1.099.43-2.147 1.18-2.876.662-.645 1.512-.986 2.4-.96 1.868.054 3.388 1.829 3.388 3.956v27.46c0 1.07.856 1.942 1.923 1.961a1.966 1.966 0 001.99-1.891c.073-2.067 1.601-3.686 3.48-3.686 1.921 0 3.484 1.721 3.484 3.837v7.02a1.96 1.96 0 001.957 1.96c1.081 0 1.957-.878 1.957-1.96 0-2.117 1.563-3.838 3.485-3.838 1.92 0 3.484 1.721 3.484 3.837v5.647c0 .244.045.487.134.714l.1.256a1.96 1.96 0 002.011 1.238 1.958 1.958 0 001.737-1.602c.324-1.786 1.76-3.082 3.416-3.082 1.895 0 3.441 1.675 3.483 3.751l-1.761 18.15zM92.53 50.938c-1.25 0-2.44.33-3.484.915v-.164c0-4.278-3.32-7.759-7.399-7.759a7.083 7.083 0 00-3.484.916v-.176c0-4.278-3.318-7.759-7.398-7.759a7.13 7.13 0 00-3.479.902V16.989c0-4.227-3.224-7.76-7.188-7.876-1.95-.054-3.814.677-5.242 2.066-1.503 1.464-2.366 3.538-2.366 5.69v46.357l-5.813-7.856c-3.17-4.284-8.76-5.512-13.293-2.919-1.884 1.078-2.57 3.541-1.53 5.49 3.502 6.556 12.207 22.525 17.519 29.437.718 1.047 8.984 12.622 23.31 12.622 7.933 0 14.608-2.841 19.303-8.217 3.44-3.94 5.627-9.14 6.161-14.642l1.772-18.254c.006-.063.009-.127.009-.19 0-4.278-3.319-7.759-7.398-7.759z"
  ></path>
</svg>
</div>
            </div>

</div>

</section >

<SimpleSlider></SimpleSlider>

    <div className="wrap about-textBlock">

        <div className="grid -center" >

        <div className="col_xs-100  col-65 ">
          <p className="p-big">

        {  context.state.translation.default.about.introP2}
          </p>
  </div>
        </div>

</div>


      </Page>
    )}
  </MyContext.Consumer>
    );

  }
}

export default About;


{
  // import React from "react";
  // import Page from "./Page";
  // import Footer from "./Footer";
  // import Link from 'react-router-dom/Link';
  // import illuDesign from './assets/img/illuDesign.svg';
  // import illuKonzeption from './assets/img/illuKonzeption.svg';
  // import phil from "./assets/img/banana2.jpg";
  // import philAtWork from "./assets/img/philAtWork.png";
  // import illuEntwicklung from './assets/img/illuEntwicklung.svg';
  //
  // import { Controller, Scene } from "react-scrollmagic";
  //
  //
  // class About extends React.Component {
  //
  //   constructor(props) {
  //     super(props);
  //     this.state = {
  //     };
  //   }
  //   componentDidMount() {
  //   }
  //
  //
  //   render() {
  //     return (
  //       <Page
  //         pageName="About"
  //                 loaderText="Das bin ich"
  //         pageType="About"
  //         pageHero="Digitale Produkte, die Spaß machen."
  //         pageStyle="bright"
  //       >
  //         <img className="bigImage-portrait"
  //           alt="Foto von Philipp"
  //           title="Foto eines 30 Jährigen (jupp) jungen Mannes."
  //           src={phil}
  //         />
  //     <div className="wrap grid">
  //
  //         <div className="col-40_sm-100">
  //         <h3>Ich biete die ideale Kombination aus Kreativität und technischem Verständnis.</h3>
  //         </div>
  //
  //
  //
  //
  //         <div  data-push-left="off_sm-0 off-5" className="col-55_sm-100">
  // <p>
  // Ich bin Philipp Wienes, studierter, freiberuflicher Gestalter, Entwickler und Medienkünstler aus Bremen.
  // Seit über 8 Jahren entwerfe ich hochwertige Benutzeroberflächen und Brandings für Unternehmen aus allen Bereichen.
  // Mein Hauptziel ist es, schöne, intuitiv bedienbare, digitale Erlebnisse zu gestalten, die im Kopf bleiben.
  // Ich liebe einfache Formen, neue Technologien und klare Farbwelten.
  // </p>
  // </div>
  //
  //
  //   <div className="col-100_sm-100">
  //
  // <img className="img"     title="Foto eines fleißigen Gestalters bei der Arbeit." style={{marginTop: '4em', marginBottom: '2em'}} src={philAtWork}/>
  // </div>
  //
  //
  //       <div style={{marginTop: '2em'}} data-push-left="off-15 off_sm-0" className="col-70_sm-100">
  // <p>
  //     Am liebsten arbeite ich mit innovativen finetech Firmen an digitalen Produkten der Zukunft.
  //     Mein Herz schlägt aber auch für all die Künstler aus den unterschiedlichsten Bereichen da draußen.
  //     Wenn du dich angesprochen fühlst, und Hilfe bei deiner digitalen Präsenz brauchst, melde dich sehr gerne bei mir.
  //     Und keine Angst, über Geld redet man. 😊👆 Schreibt mir einfach, ein Gespräch kostet nichts und man weiß nie wohin es führen könnte. 😊
  //
  // </p>
  //
  // </div>
  //     <div  className="col-100_sm-100">
  //
  // <blockquote>"Zukunftsforschung ist die Kunst, <br/>sich zu kratzen, bevor es juckt. "</blockquote>
  //
  // </div>
  //         <div  data-push-left="off-15 off_sm-0" className="col-70_sm-100">
  // <p >
  // Neben meiner Arbeit als Freiberufler, entwickle ich medienkünstlerische Arbeite, die sich im Zwischenraum von Kunst, Design und Technologie bewegen.
  // In ihnen versuche ich auf spielerische Art den
  // Zeitgeist der technologisierten Gesellschaft widerzugeben.
  //
  // Für meine Arbeiten bin ich immer auf der Suche nach
  //   geeigneten Ausstellungsmöglichkeiten.
  //  </p>
  //
  // </div>
  //
  // </div>
  //
  //       </Page>
  //     );
  //   }
  // }
  //
  // export default About;
}
